var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCydea(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 59,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.654 37.633c.624 0 1.153.227 1.587.68.454.435.68.964.68 1.587s-.236 1.18-.708 1.672c-2.928 2.55-6.376 3.826-10.344 3.826-4.383 0-8.123-1.55-11.222-4.648C1.55 37.652 0 33.911 0 29.528c0-4.383 1.55-8.123 4.647-11.222 3.099-3.098 6.84-4.647 11.222-4.647 3.968 0 7.416 1.275 10.344 3.826.529.472.793 1.058.793 1.757 0 .623-.227 1.162-.68 1.615a2.16 2.16 0 01-1.587.652c-.548 0-1.03-.17-1.445-.51-2.116-1.87-4.59-2.806-7.425-2.806-3.136 0-5.809 1.105-8.02 3.316-2.21 2.21-3.315 4.883-3.315 8.02 0 3.135 1.105 5.809 3.316 8.019 2.21 2.21 4.883 3.316 8.02 3.316 2.833 0 5.299-.926 7.396-2.777.396-.303.86-.454 1.388-.454z",
    fill: "url(#cydea_svg__paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.876 43.102L31.994 16.975a2.205 2.205 0 01-.255-1.049c0-.623.217-1.152.652-1.587.453-.453.991-.68 1.615-.68.623 0 1.162.217 1.615.652.246.264.425.548.538.85l9.182 22.019 9.182-22.02c.113-.301.302-.585.566-.85a2.16 2.16 0 011.587-.651c.624 0 1.153.227 1.587.68.454.435.68.964.68 1.587 0 .378-.085.727-.255 1.048l-16.89 40.524a2.296 2.296 0 01-.538.822c-.453.453-.991.68-1.615.68a2.207 2.207 0 01-1.615-.68 2.16 2.16 0 01-.652-1.587c0-.378.085-.727.255-1.049l5.243-12.582z",
    fill: "url(#cydea_svg__paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.682 29.528c0-3.136-1.105-5.809-3.316-8.02-2.21-2.21-4.883-3.315-8.02-3.315-3.135 0-5.809 1.105-8.019 3.316-2.21 2.21-3.316 4.883-3.316 8.02 0 3.135 1.106 5.809 3.316 8.019s4.884 3.316 8.02 3.316c3.136 0 5.81-1.106 8.02-3.316s3.315-4.884 3.315-8.02zm0-27.26c0-.624.217-1.153.652-1.588.453-.453.992-.68 1.615-.68.624 0 1.153.227 1.587.68.453.435.68.964.68 1.587v27.261c0 4.383-1.549 8.124-4.647 11.222-3.099 3.099-6.84 4.648-11.222 4.648-4.383 0-8.124-1.55-11.222-4.648-3.098-3.098-4.648-6.839-4.648-11.222 0-4.383 1.55-8.123 4.648-11.222 3.098-3.098 6.839-4.647 11.222-4.647 4.383 0 8.123 1.55 11.222 4.647l.113.114V2.267z",
    fill: "url(#cydea_svg__paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M126.756 27.261c-.415-2.172-1.454-4.09-3.117-5.752-2.21-2.21-4.883-3.316-8.019-3.316s-5.81 1.105-8.02 3.316c-1.663 1.662-2.702 3.58-3.117 5.752h22.273zm-2.408 10.429c.623 0 1.152.226 1.587.68.453.434.68.963.68 1.587 0 .623-.217 1.162-.652 1.615-2.928 2.55-6.376 3.826-10.343 3.826-4.383 0-8.124-1.55-11.222-4.648-3.099-3.098-4.648-6.839-4.648-11.222 0-4.383 1.549-8.123 4.648-11.222 3.098-3.098 6.839-4.647 11.222-4.647 4.383 0 8.123 1.55 11.221 4.647 3.099 3.099 4.648 6.84 4.648 11.222 0 .624-.227 1.162-.68 1.616a2.161 2.161 0 01-1.587.651h-24.739c.415 2.173 1.454 4.09 3.117 5.753 2.21 2.21 4.884 3.316 8.02 3.316 2.833 0 5.27-.898 7.311-2.692a2.255 2.255 0 011.417-.482z",
    fill: "url(#cydea_svg__paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M151.892 18.193c-3.136 0-5.809 1.105-8.019 3.316-2.211 2.21-3.316 4.883-3.316 8.02 0 3.135 1.105 5.809 3.316 8.019 2.21 2.21 4.883 3.316 8.019 3.316s5.81-1.106 8.02-3.316 3.316-4.884 3.316-8.02c0-3.136-1.106-5.809-3.316-8.02-2.21-2.21-4.884-3.315-8.02-3.315zm11.336 22.444c-3.174 3.174-6.953 4.76-11.336 4.76s-8.123-1.548-11.221-4.647c-3.099-3.098-4.648-6.839-4.648-11.222 0-4.383 1.549-8.123 4.648-11.222 3.098-3.098 6.838-4.647 11.221-4.647s8.124 1.55 11.222 4.647c3.099 3.099 4.648 6.84 4.648 11.222v13.603c0 .623-.227 1.161-.68 1.615a2.161 2.161 0 01-1.587.652 2.257 2.257 0 01-1.616-.652 2.256 2.256 0 01-.651-1.615v-2.494z",
    fill: "url(#cydea_svg__paint4_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cydea_svg__paint0_linear",
    x1: 0,
    y1: 0,
    x2: 127.225,
    y2: 104.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#E62E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD5630"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cydea_svg__paint1_linear",
    x1: 0,
    y1: 0,
    x2: 127.225,
    y2: 104.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#E62E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD5630"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cydea_svg__paint2_linear",
    x1: 0,
    y1: 0,
    x2: 127.225,
    y2: 104.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#E62E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD5630"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cydea_svg__paint3_linear",
    x1: 0,
    y1: 0,
    x2: 127.225,
    y2: 104.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#E62E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD5630"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cydea_svg__paint4_linear",
    x1: 0,
    y1: 0,
    x2: 127.225,
    y2: 104.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#E62E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD5630"
  })))));
}
export default __webpack_public_path__ + "static/cydea.482dd601.svg";
export { SvgCydea as ReactComponent };